import React, { Component } from "react";

//import { TooltipControls } from '../TooltipControls';
import { toast } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"
import { css } from 'glamor'
import Toast from '../../../toast/Toast'
import colors from  '@learningblocks/protocol-constants/lib/Styles/_colors.scss';

import { Transilluminator } from "@learningblocks/storybook-components/lib/ProtocolComponents/Transilluminator";
// const images = {
//   TransilluminatorOpen,
//   TransilluminatorOpenWithGel,
//   TransilluminatorClosed,
//   TransilluminatorClosedWithGel,
//   TransilluminatorClosedWithGelIlluminated,
// };

export class Graphics extends Component {

  constructor(props){
    super(props);
    this.state = {
      lastX:0,
      lastY:0
    }
  };
  toggleToolTipControls = (showControls) => {
    this.props.toggleToolTipTransillimunatorControls({
      id: this.props.id,
      showToolTipControls: showControls
    })
  }

  toggleOpen = () => {

    if(this.props.on){
      this.makeToast("","Please turn off the transilluminator before opening the lid", "Safety hazzard");
      return
    }
    const payload = {
      id: 1,
      open: !this.props.open,
    }
    this.props.transilluminatorOpen(payload);
  };

  ejectGel = () => {
    this.props.setGelInScene({
      id: 1,
      inScene: true,
    });
    this.props.setGelInTransilluminator({
      id: this.props.id,
      containsGel: false,
    });
    this.props.setGelOnShelf({
      id: 1,
      onShelf: true
    });
  }

  showModal = () =>{
    this.props.setModal({
      display: false,
      type: "TRANSILLUMINATOR_CONTROLS",
      size: 'inside',
      connect: -1
    })
    this.props.showModal({display: true})
  }

  makeToast = (type, msg, title) => {
      let color = ""
      if(type==="HINT"){
        color = colors.yellow1
      } else {
        color = colors.red1
      }

      toast(<Toast type={type} msg={msg} title={title} />, {
        className: css({
          border: "2px solid "+color,
          borderRadius: "6px",
          marginLeft: "-200px",
          minWidth: "400px",
          paddingLeft: 0
        }),
        progressClassName: css({
          background: color
        }),
        position: "top-center",
        autoClose: 5000,
      });
  };

  // function for triggering mouse events
  fireMouseEvent = (type, elem, centerX, centerY) => {
    var evt = document.createEvent('MouseEvents');
    evt.initMouseEvent(type, true, true, window, 1, 1, 1, centerX, centerY, false, false, false, false, 0, elem);

    evt.dataTransfer = new DataTransfer();
    elem.dispatchEvent(evt);
  };

  render() {
    return (
      <Transilluminator
        open={this.props.open}
        on={this.props.on}
        containsGel={this.props.containsGel}
        gelExamined={this.props.gelExamined}
        gelOrientation={this.props.gelOrientation}
        level={this.props.level}
        //actualData={}
        interactionProps={this.props.interactionProps}


        toggleShowTransilluminatorControlsModal={(props) =>
          this.props.toggleTransilluminatorControlsModal({
            id: this.props.id,
            showControlsModal: props
          })
        }
        showControlsModal={this.props.showControlsModal}
        showTooltipControls={this.props.showToolTipControls}
        toggleShowTooltipControls={this.toggleToolTipControls}
        toggleLid={this.toggleOpen}
        ejectGel={this.ejectGel}
      />
    );
  }
}